module.exports = __webpack_public_path__ + "img/destination_bluesafari_ln.82c675ea.jpg";